exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-380c11d3],.list[data-v-380c11d3]{overflow:hidden}.item[data-v-380c11d3]{float:left;background:#ebebeb;width:46px;height:46px;border-radius:50%;margin-bottom:14px;position:relative}.item.more[data-v-380c11d3]{background:transparent;border:1px solid #eee}.item[data-v-380c11d3]:not(:nth-child(5n)){margin-right:17px}.item .ico[data-v-380c11d3]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%) scale(.5);transform:translate(-50%,-50%) scale(.5);color:#dbdbdb}.item img[data-v-380c11d3]{display:block;width:100%;height:100%;-o-object-fit:cover;object-fit:cover}", ""]);

// exports
